import { useLayoutEffect } from "react";
import { useLocation } from "react-router-dom";

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    document.documentElement.scrollTop = 0;
    document.body.scrollTop = 0;

    document
      .querySelectorAll(".admin-main, .admin-body, .admin-content, .admin-right")
      .forEach((el) => {
        el.scrollTop = 0;
      });
  }, [pathname]);

  return null;
}

export default ScrollToTop;
